import { MAX_ITINERARIES } from '../../constants/constants'

export function canLoadMoreitins(upperBound, totalItineraries) {
  //   enable and disable functions for the infinite scroll
  let loadMore = true
  // we are over our max, don't go fetch any more
  if (upperBound >= MAX_ITINERARIES) {
    loadMore = false
  }

  /**
   *   upperbound and totalItineraries have same value from BE response when
   *   We have fetched all that we can fetch. Dont use request UpperBound here
   */
  if (upperBound >= totalItineraries) {
    loadMore = false
  }

  return loadMore
}
